import { render, staticRenderFns } from "./ProgramGroupItemForm.vue?vue&type=template&id=4897bcae"
import script from "./ProgramGroupItemForm.vue?vue&type=script&lang=js"
export * from "./ProgramGroupItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports